<template>
  <!-- 隱私權政策視窗 -->
  <ui-modal
    ref="merchantBranchesModal"
    :header-title="$t('switch_branch')"
    :forcing="true"
    :hide-overlay="false"
    modal-width="100%"
    max-width="480"
    @close-icon-event="closeModal"
  >
    <v-sheet class="merchant-branches__container">
      <v-radio-group v-model="radioBranchID" class="ma-0">
        <v-radio v-for="item in items" :key="item.bid" class="branch-radio px-5" :label="item.name" :value="item.bid" color="orange50">
          <template #label>
            <div class="wd-text-black50">{{ item.name }}</div>
          </template>
        </v-radio>
      </v-radio-group>
    </v-sheet>

    <template #buttons>
      <div class="event-buttons-group">
        <v-btn
          class="confirm-btn text-white"
          type="submit"
          :color="'orange50'"
          :min-width="66"
          :min-height="40"
          variant="flat"
          @click="doPathOnBranches"
        >
          {{ $t('all_ok') }}
        </v-btn>
      </div>
    </template>
  </ui-modal>
</template>

<script>
import { templateRef } from '@vueuse/core'
import { usePlatformStore } from '@/store-pinia/platform'
import { switchBranchAndRedirect } from '@/utils/funbookV2'

import UiModal from '@/components/dialog/ui-modal.vue'

export default defineComponent({
  name: 'MerchantBranchesModal',
  components: {
    UiModal,
  },
  props: {
    branchId: { type: Number, default: null },
    items: { type: Array, default: () => [] },
  },
  setup(props) {
    const nuxtApp = useNuxtApp()
    const route = useRoute()
    const routeQuery = computed(() => route.query)
    const router = useRouter()
    const merchantBranchesModal = templateRef('merchantBranchesModal')

    const { isFunBookV2DomainCustomization } = storeToRefs(usePlatformStore())
    const radioBranchID = ref(props.branchId || null)

    watch(
      () => props.branchId,
      newBranchID => {
        radioBranchID.value = newBranchID
      }
    )

    function showModal() {
      merchantBranchesModal.value.showModal()
    }

    function closeModal() {
      merchantBranchesModal.value.hideModal()
    }

    function doPathOnBranches() {
      if (radioBranchID.value === props.branchId) {
        closeModal()
        return
      }

      if (!isFunBookV2DomainCustomization.value) {
        const path = nuxtApp.$localePath({ name: 'branches-id-funbook', params: { id: radioBranchID.value }, query: getRouterQueryWithoutRwgInfo() })
        router.push(path)
        return
      }
      switchBranchAndRedirect(nuxtApp.$axios, radioBranchID.value, nuxtApp.$i18n.locale.value)
    }

    function getRouterQueryWithoutRwgInfo() {
      const { rwg_token, ...restQuery } = routeQuery.value || {}

      return restQuery
    }

    return {
      radioBranchID,
      showModal,
      closeModal,
      doPathOnBranches,
    }
  },
})
</script>

<style lang="scss" scoped>
.merchant-branches__container {
  width: 480px;
  height: calc(100vh - 48px - 64px);
  max-height: 255px;
  overflow-y: auto;
  box-shadow: inset 0 -10px 10px -10px #dedede;

  @include xxs {
    width: 100%;
  }

  .branch-radio {
    padding: 16px 20px;
    border-bottom: 1px solid $gray40;
  }
}
</style>
